import { formatNumber, normalize } from './utils';

import { Input } from './Input';

const normalizeNumber = normalize('number');

export const Number = (props) => (
  <Input {...props} normalize={normalizeNumber} format={formatNumber} type="text" />
);
